import src from "IMAGE";
export default { src, width: 1257, height: 251, blurWidth: 8, blurHeight: 2, blurDataURL: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAACCAYAAABllJ3tAAAAOklEQVR42j3Huw3AIAwAUfafLQkLBEHLRwIMrg9XFE+6c18ovKHiU8PHxmN//Rm3ZbKMqqB7IdbX6ByB/ztPz5WOlgAAAABJRU5ErkJggg=="};
